/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.EftControlPanel {

    export class EFTControlPanelAPI extends Meevo.Components.Common.DataService {
        static factory(): Function {
            const factory = (appSettings: Meevo.Components.Common.IAppSettings,
                             $http: angular.IHttpService,
                             $q: angular.IQService,
                             identityService: Meevo.Components.Common.IIdentityService,
                             $cookies: angular.cookies.ICookiesService) => {
                return new EFTControlPanelAPI(appSettings, $http, $q, identityService, $cookies);
            }

            factory.$inject = [
                'meevo.AppSettings',
                '$http',
                '$q',
                'meevo.components.common.IdentityService',
                '$cookies'
            ];

            return factory;
        }

        processPaymentPlan(requestBody: IPaymentPlanProcessRequest): ng.IPromise<IPaymentPlanProcessResponse> {
            return this.customMethodData('api/PaymentPlan/EFT/Process', 'PATCH', requestBody).then(res => res.data);
        }
    }

    angular.module('meevo.plugins.eftControlPanel')
        .service('meevo.plugins.eftControlPanel.EFTControlPanelAPI', EFTControlPanelAPI.factory());
}
